import { useState, useEffect } from "react";
import { TESTIMONIALS, GOOGLE_REVIEW_URL } from "@/data/content";
import { ChevronLeft, ChevronRight, Quote, Star } from "lucide-react";
import BookingButton from "./BookingButton";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];

  useEffect(() => {
    const id = setInterval(() => setI((x) => (x + 1) % TESTIMONIALS.length), 7000);
    return () => clearInterval(id);
  }, []);

  return (
    <section
      className="py-28 lg:py-36 border-y"
      style={{ background: "var(--sano-bg-3)", borderColor: "var(--sano-border)" }}
      data-testid="testimonials-section"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <div className="eyebrow mb-3">04 · Voices from the table</div>
        <div className="flex items-center justify-center gap-1 mb-6" data-testid="testimonials-stars">
          {[0,1,2,3,4].map((i) => (
            <Star key={i} size={16} strokeWidth={1.5} fill="currentColor" style={{ color: "var(--sano-clay)" }} />
          ))}
          <span className="ml-2 text-xs uppercase tracking-widest" style={{ color: "var(--sano-ink-2)" }}>
            Google Reviewed
          </span>
        </div>
        <Quote size={36} strokeWidth={1.2} className="mx-auto mb-8" style={{ color: "var(--sano-clay)" }} />
        <blockquote
          key={i}
          className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.15] italic soft-up"
          data-testid="testimonial-quote"
        >
          “{t.quote}”
        </blockquote>
        <div className="mt-10 text-sm uppercase tracking-widest" style={{ color: "var(--sano-ink-2)" }}>
          {t.name} — {t.role}
        </div>

        <div className="mt-12 flex items-center justify-center gap-4">
          <button
            onClick={() => setI((x) => (x - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)}
            className="p-3 rounded-full border hover:bg-[#F9F6F0] transition"
            style={{ borderColor: "var(--sano-border)" }}
            aria-label="Previous testimonial"
            data-testid="testimonial-prev"
          >
            <ChevronLeft size={18} strokeWidth={1.5} />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setI(idx)}
                className="h-1.5 rounded-full transition-all"
                style={{
                  width: idx === i ? 28 : 8,
                  background: idx === i ? "var(--sano-olive)" : "var(--sano-border)",
                }}
                aria-label={`Go to testimonial ${idx + 1}`}
                data-testid={`testimonial-dot-${idx}`}
              />
            ))}
          </div>
          <button
            onClick={() => setI((x) => (x + 1) % TESTIMONIALS.length)}
            className="p-3 rounded-full border hover:bg-[#F9F6F0] transition"
            style={{ borderColor: "var(--sano-border)" }}
            aria-label="Next testimonial"
            data-testid="testimonial-next"
          >
            <ChevronRight size={18} strokeWidth={1.5} />
          </button>
        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-4 items-center">
          <BookingButton testid="testimonials-book-btn" label="Become a Sano client" />
          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noreferrer"
            className="text-sm border-b border-current pb-0.5"
            style={{ color: "var(--sano-olive)" }}
            data-testid="testimonials-google-reviews"
          >
            Read more reviews on Google →
          </a>
        </div>
      </div>
    </section>
  );
}
